import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

// Deep link support: ?<param>=<id> runs `onFound(id)` once data is ready, then drops the param.
export function useDeepLink(param, ready, onFound) {
  const [params, setParams] = useSearchParams();
  const id = params.get(param);
  useEffect(() => {
    if (!ready || !id) return;
    onFound(id);
    const next = new URLSearchParams(params);
    next.delete(param);
    setParams(next, { replace: true });
  }, [ready, id]); // eslint-disable-line react-hooks/exhaustive-deps
}

export const flashRecord = (id) => {
  requestAnimationFrame(() => {
    const el = document.querySelector(`[data-record-id="${CSS.escape(id)}"]`);
    if (!el) return;
    el.scrollIntoView({ block: "center", behavior: "smooth" });
    el.classList.add("record-focus");
    setTimeout(() => el.classList.remove("record-focus"), 2600);
  });
};
